import btn2 from './btn2.vue';
btn2.install = Vue => Vue.component(btn2.name,btn2);
export default btn2;



// WEBPACK FOOTER //
// ./src/packages/button/btn2/index.js